import React, { useState } from "react";
import { sizingChart } from "@/mock";
import { Ruler } from "lucide-react";

export default function Sizing() {
  const [active, setActive] = useState("M");
  return (
    <section id="sizing" className="bg-[#0a0a0a] text-white py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <div className="text-[11px] tracking-[0.28em] text-[#ff2626] font-bold uppercase mb-3">
            Find your fit
          </div>
          <h2 className="text-4xl md:text-5xl font-black tracking-tight leading-[1.02]">
            SIZING
            <br />
            <span className="text-[#ff2626]">MADE SIMPLE</span>
          </h2>
          <p className="mt-5 text-white/60 max-w-md text-[15px] leading-relaxed">
            Between sizes? Size up for a relaxed fit or down for a snug feel. Free exchanges on all
            first orders.
          </p>
          <div className="mt-8 inline-flex items-center gap-2 text-[12px] tracking-[0.18em] uppercase text-white/50">
            <Ruler size={16} /> Measure at the natural waistline
          </div>
        </div>

        <div className="bg-white/[0.03] border border-white/10 p-6">
          <div className="grid grid-cols-5 gap-2 mb-6">
            {sizingChart.map((s) => (
              <button
                key={s.size}
                onClick={() => setActive(s.size)}
                className={`py-3 text-[13px] font-black tracking-[0.08em] border transition-all ${
                  active === s.size
                    ? "bg-[#c60d0d] border-[#c60d0d] text-white"
                    : "bg-transparent border-white/20 text-white/80 hover:border-white/60"
                }`}
              >
                {s.size}
              </button>
            ))}
          </div>

          <table className="w-full text-[13px]">
            <thead>
              <tr className="text-white/50 text-[11px] tracking-[0.18em] uppercase">
                <th className="text-left pb-3">Size</th>
                <th className="text-left pb-3">Waist</th>
                <th className="text-left pb-3">Hip</th>
              </tr>
            </thead>
            <tbody>
              {sizingChart.map((s) => (
                <tr
                  key={s.size}
                  className={`border-t border-white/10 ${
                    active === s.size ? "text-[#ff2626] font-bold" : "text-white/80"
                  }`}
                >
                  <td className="py-3">{s.size}</td>
                  <td className="py-3">{s.waist}</td>
                  <td className="py-3">{s.hip}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
